import React, { useRef, useState } from "react";
import "./IndiaSec3.css";
import Slider from "react-slick";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

export const IndiaSec3 = ({ data, name }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => setSlideIndex(current),
    arrows: false,
    dots: false,
  };

  return (
    <div className="kenyasec2 standard-padding">
      {/* HEADER */}
      <div className="kenyasec2-head d-flex justify-content-center align-items-center">
        <h1 className="heading">Top Places to Visit in {name}</h1>
      </div>

      {/* SLIDER WRAPPER */}
      <div className="kenyasec2-slider-wrapper">
        {/* Left Arrow (Desktop Only) */}
        {window.innerWidth >= 900 && (
          <div
            className="kenyasec2-side-arrow kenyasec2-side-arrow-left"
            onClick={() => sliderRef.current?.slickPrev()}
          >
            <MdOutlineKeyboardArrowLeft />
          </div>
        )}

        <div className="kenyasec2-slider-inner">
          <Slider ref={sliderRef} {...settings}>
            {data?.map((d, index) => (
              <div key={index}>
                {/* Relative Outer Slide Wrapper */}
                <div className="kenyasec2-slide-container">
                  {/* Background Image Container */}
                  <div
                    className="kenyasec2-slide-bg"
                    style={{ backgroundImage: `url(${d.img})` }}
                  />

                  {/* Absolute Overlay Card */}
                  <div className="kenyasec2-overlay-card">
                    <p className="kenyasec2-overlay-title">{d.title}</p>
                    {Array.isArray(d.desc) ? (
                      d.desc.map((text, idx) => (
                        <p key={idx} className="kenyasec2-slider-desc">
                          {text}
                        </p>
                      ))
                    ) : (
                      <p className="kenyasec2-slider-desc">{d.desc}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Right Arrow (Desktop Only) */}
        {window.innerWidth >= 900 && (
          <div
            className="kenyasec2-side-arrow kenyasec2-side-arrow-right"
            onClick={() => sliderRef.current?.slickNext()}
          >
            <MdOutlineKeyboardArrowRight />
          </div>
        )}
      </div>

      {/* DOT INDICATORS */}
      <div className="kenyasec2-dots d-flex justify-content-center gap-2 mt-4">
        {data?.map((_, idx) => {
          const total = data.length;

          // 3-dot window pagination
          if (
            idx === slideIndex ||
            idx === (slideIndex - 1 + total) % total ||
            idx === (slideIndex + 1) % total
          ) {
            return (
              <span
                key={idx}
                className={`kenyasec2-dot ${idx === slideIndex ? "active" : ""}`}
                onClick={() => sliderRef.current?.slickGoTo(idx)}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};